import {Component} from '@angular/core';

/**
 * Dialog box for confimration of leaving a page
 */
@Component({
  selector: 'app-leave-confirmation',
  templateUrl: './leave-confirmation.component.html'
})
export class LeaveConfirmationComponent {
  public resolve: any;
  public reject: any;
  public show: boolean = false;

  constructor() {
  }

  /**
   * This will open the confirmation modal
   */
  public showModal(resolve: any, reject: any): any {
    this.show = true;
    this.resolve = resolve;
    this.reject = reject;
  }

  /**
   * This will reject the dialog
   */
  public onDismiss(): any {
    this.resolve(false);
    this.show = false;
  }

  /**
   * This will confirm the dialog
   */
  public onConfirm(): any {
    this.resolve(true);
    this.show = false;
  }

}
